<div class="content">
    <div class="content">
     <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 common_title">
          <h2>
            EDIT - ANIMAL DEWORMING DETAIL
            </h2>
         <!-- <p>Edit animal deworming detail</p>-->
          <!--<a (click)="backnavigate()"  class="back_to"><i class="fa fa-chevron-left" aria-hidden="true"></i>
           Back
          </a>-->
          </div>
      </div>
     <br>
       <form class="row bottomheight">
        <div class="col-lg-4 col-md-6 col-sm-6">
          <div class="form-group">
            <label for="Species Name" >Deworming Name</label>
            <input type="text" name="dewormingname" id="dewormingname"  value="" class="form-control">
            </div>
         </div>
        <div class="col-lg-4 col-md-6 col-sm-6">
            <div class="form-group">
              <label for="Species Name" >Deworming Date</label>
              <input type="date" name="DeworminDate" id="DewormingDate"  value="" class="form-control">
              </div>
           </div>
          <div class="col-lg-4 col-md-6 col-sm-6">
            <div class="form-group">
              <label for="Species Name" >Batch No</label>
              <input type="text" name="batchNumber" id="batchNumber"  value="" class="form-control">
              </div>
           </div>
           <div class="col-lg-4 col-md-6 col-sm-6">
            <div class="form-group">
              <label for="Species Name" >Expiry Date </label>
              <input type="date" id="ExpiryDate" name="expirydate" value="Cow" class="form-control">
              </div>
           </div>
       <div class="col-lg-4 col-md-6 col-sm-6">
        <div class="form-group">
          <label for="Species Name" >Description</label>
          <textarea id="Description" name="Description" class="form-control"></textarea>
       </div>
    </div>
         <div class="col-lg-12 col-md-12 col-sm-12 text-center">
        <button type="submit" class="btn btn-fill btn-primary mb-3"  (click)="AnimalDeworming()">Submit<div class="ripple-container"></div></button>
        <button  (click)="backnavigate()" class="btn btn-fill btn-default">Cancel<div class="ripple-container"></div></button>
        </div>
       </form>
      
     </div>
   </div>
  </div>
  
  